import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "row align-items-center d-flex" }
const _hoisted_3 = { class: "col-9 fw-bold" }

import useToast from '@/composables/useToast';
import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'PixCodeComponent',
  props: {
    code: {}
  },
  setup(__props: any) {

const { toastSuccess } = useToast()
const props = __props

const limitedCode = computed(() => props.code)

const handleCopy = () => {
    navigator.clipboard.writeText(props.code);
    toastSuccess('Código copiado!')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card mt-4 bg-primary-soft",
    onClick: handleCopy
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(limitedCode.value), 1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-3 text-end" }, [
          _createElementVNode("button", { class: "btn btn-link fs-2 p-0" }, [
            _createElementVNode("i", { class: "far fa-copy" })
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})